// extracted by mini-css-extract-plugin
export default {"backdrop":"Modal_backdrop__Ovtnz","modal":"Modal_modal__ZjBx1","slide-down":"Modal_slide-down__u3KgC","success":"Modal_success__dJWop","font-trial":"Modal_font-trial__OEvLg"};